import React, { useEffect } from 'react';
import { IRootState } from 'src/reducers';
import { useSelector } from 'react-redux';
import useFetch from 'use-http';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
// import { ResolverResult } from 'react-hook-form/dist/types/form';

type ToDepthHorizon = {
    toDescription: string;
    isCenterEarth: boolean;
    toDepth: number;
    formationId?: number;
    formationName?: string;
    sequence: number;
    horizons?: unknown[];
};

type DraggableItem = {
    uniqueId: string;
    data: ToDepthHorizon | (ToDepthHorizon & { uniqueId: string })[];
};

const formatResults = (data: ToDepthHorizon[]) => {
    return data.map((item: ToDepthHorizon) => {
        return {
            uniqueId: `_${Math.random().toString(36).substr(2, 9)}`,
            data: item,
        };
    });
};

// const onDragEnd = (result: DropResult, provided:  ) => {
// }Vl

const SectionHorizonSequence = () => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, response } = useFetch();
    const [data, setData] = React.useState<DraggableItem[]>([]);

    const loadData = async () => {
        const result = await get(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/fields/${appContext.fieldNumber}/horizons`
        );

        if (response.ok) {
            setData(formatResults(result));
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const getItemStyle = (isDragging: boolean, draggableStyle: React.CSSProperties): React.CSSProperties => ({
        userSelect: 'none',
        padding: '1rem',
        margin: '0 0 .5rem 0',
        background: isDragging ? 'lightblue' : 'white',
        ...draggableStyle,
    });

    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? '#f1f1f1' : 'lightgrey',
        padding: '.5rem',
        width: '250px',
    });

    return (
        <DragDropContext
            onDragEnd={(result, provided) => {
                console.log(result, provided);
            }}
        >
            <Droppable droppableId="section-horizon-panel">
                {(outerProvided, outerSnapshot) => (
                    <div {...outerProvided.droppableProps} ref={outerProvided.innerRef} style={getListStyle(outerSnapshot.isDraggingOver)}>
                        {data.map((item: DraggableItem, index: number) => (
                            <Draggable key={item.uniqueId} draggableId={item.uniqueId} index={index}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                    >
                                        <span>{(item.data as ToDepthHorizon).toDescription || ''}</span>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {outerProvided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default SectionHorizonSequence;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/SectionHorizonSequence.tsx